import { salesforceBaseURL } from "constants/endpoints";

export type SupportTopic = "Order Help" | "Custom Quote" | "Return Authorization";

interface GetSupportFormUrlOptions {
	type: SupportTopic;
	orderNumber?: string | null;
	brand?: string | null;
	poNumber?: string | null;
}

export const getSupportFormUrl = ({ type, orderNumber, brand, poNumber }: GetSupportFormUrlOptions): string => {
	const baseUrl = `${salesforceBaseURL.replace(/\/$/, "")}/sf/support`;
	const queryParams = new URLSearchParams({ type });

	if (orderNumber?.trim()) {
		queryParams.set("order_num", orderNumber.trim());
	}

	if (brand?.trim()) {
		queryParams.set("brand", brand.trim());
	}

	if (poNumber?.trim()) {
		queryParams.set("po_num", poNumber.trim());
	}

	return `${baseUrl}?${queryParams.toString().replace(/\+/g, "%20")}`;
};
